































import {
  createComponent,
  inject,
  onMounted,
  computed,
  reactive,
  ref
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import LoginKey from "@/components/login-key";
import DialogLoginError from "../../../views/Auth/DialogLoginError.vue";
import DialogConfirmAccount from "./DialogConfirmAccount.vue";
import router from "../../../router";
import customValidator from "@/lib/customValidator.ts"

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const login = inject(LoginKey);
    if (!login) {
      throw new Error(`${LoginKey} is not provided`);
    }

    const loginForm = ref(null)
    const validator = customValidator;

    onMounted(() => {
      displayui.closeDialogConfirmAccount();
    });

    const loginInfor = computed(() => login.loginInfor);
    const changeShowPassword = login.changeShowPassword;
    const state = reactive({
      token: ""
    });
    const submit = async () => {
      //@ts-ignore
      if(!loginForm.value.validate()){
        return
      }
      const submitLogin = (await login.submit()) as any;
      if (submitLogin.data) {
        await displayui.openDialogLoginError();
      } else {
        const loginResponse = (await computed(
          () => login.loginInfor.loginResponse
        )) as any;
        state.token = loginResponse.value.token;
        if (loginResponse.value.agreement_flg === 0) {
          displayui.openDialogConfirmAccount();
        } else {
          await window.localStorage.setItem(
            "token",
            "JWT " + loginResponse.value.token
          );
          await window.localStorage.setItem(
            "refresh",
            loginResponse.value.refresh
          )
          await router.push("/company_detail");
        }
      }
    };
    return {
      loginInfor,
      submit,
      changeShowPassword,
      state,
      loginForm,
      customValidator
    };
  },
  components: {
    DialogLoginError,
    DialogConfirmAccount,
    
  }
});
